import { useState, useEffect } from 'react'
import { Outlet, NavLink } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { LuWallet, LuArrowLeftRight, LuList, LuLogOut, LuCirclePlus, LuUsers, LuClipboardCheck, LuCreditCard, LuTrash2, LuBell, LuBellOff, LuFileDown, LuChartBar, LuHistory, LuMenu, LuX, LuShield, LuBuilding2, LuSearch, LuLock, LuScrollText, LuGlobe } from 'react-icons/lu'
import './Dashboard.css'

function Dashboard() {
  const { logout, userRole, roleReady, username, isPortalUser, isOperator, portalRole } = useAuth()
  const isClientAdmin = portalRole === 'administrador'
  const canEstado = isOperator || portalRole === 'principal' || isClientAdmin
  const canCoelsa = isOperator || isClientAdmin || username === 'Prueba'
  
  const [notificationsEnabled, setNotificationsEnabled] = useState(() => {
    const saved = localStorage.getItem('notifications_enabled')
    return saved === null ? true : saved === 'true'
  })
  const [showNotificationModal, setShowNotificationModal] = useState(false)
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [bellNote, setBellNote] = useState(false)
  const [profileOpen, setProfileOpen] = useState(false)
  
  const showNotificationButton = roleReady && userRole === 'CREDENCIAL' && !isOperator
  
  useEffect(() => {
    localStorage.setItem('notifications_enabled', notificationsEnabled.toString())
    window.dispatchEvent(new CustomEvent('notificationsToggle', { detail: notificationsEnabled }))
  }, [notificationsEnabled])
  
  const handleToggleNotifications = (enable) => {
    setNotificationsEnabled(enable)
    setShowNotificationModal(false)
  }

  const closeSidebar = () => setSidebarOpen(false)

  return (
    <div className="dashboard">
      {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar} />}

      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-brand-row">
            <span className="sidebar-mark" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="18" height="18">
                <path d="M13 2 4 14h7l-1 8 10-14h-7l0-6z" fill="currentColor" />
              </svg>
            </span>
            <div>
              <h1 className="sidebar-brand">Flash</h1>
              <span className="sidebar-subtitle">Operaciones</span>
            </div>
          </div>
          <button className="sidebar-close" onClick={closeSidebar} aria-label="Cerrar menú"><LuX /></button>
        </div>

        <nav className="sidebar-nav">
          <div className="sidebar-section-label">Menú principal</div>
          {roleReady && isPortalUser && userRole === 'CREDENCIAL' && (
            <>
              <NavLink to="/mis-cvus" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuCreditCard className="sidebar-icon" /><span>Mis CVUs</span>
              </NavLink>
              <NavLink to="/accounts" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuWallet className="sidebar-icon" /><span>Balance</span>
              </NavLink>
              <NavLink to="/movementsx" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuList className="sidebar-icon" /><span>Movimientos</span>
              </NavLink>
              <NavLink to="/transfer" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuArrowLeftRight className="sidebar-icon" /><span>Transferencias</span>
              </NavLink>
              {isClientAdmin && (
                <NavLink to="/usuarios" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                  <LuUsers className="sidebar-icon" /><span>Usuarios</span>
                </NavLink>
              )}
              {canEstado && (
                <NavLink to="/estado" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                  <LuClipboardCheck className="sidebar-icon" /><span>Estado</span>
                </NavLink>
              )}
              {canCoelsa && (
                <NavLink to="/consulta-coelsa" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                  <LuSearch className="sidebar-icon" /><span>Consulta Coelsa</span>
                </NavLink>
              )}
              <NavLink to="/auditoria" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuScrollText className="sidebar-icon" /><span>Auditoría</span>
              </NavLink>
              <NavLink to="/clp" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuGlobe className="sidebar-icon" /><span>CLP</span>
              </NavLink>
              <NavLink to="/seguridad" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuLock className="sidebar-icon" /><span>Seguridad</span>
              </NavLink>
              {/* Consolidación deshabilitada temporalmente
              {username === 'Prueba' && (
                <NavLink to="/consolidacion" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                  <LuChartBar className="sidebar-icon" /><span>Consolidación</span>
                </NavLink>
              )}
              */}
            </>
          )}

          {roleReady && userRole === 'CREDENCIAL' && isOperator && !isPortalUser && (
            <>
              <NavLink to="/clients" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuBuilding2 className="sidebar-icon" /><span>Clientes</span>
              </NavLink>
              <NavLink to="/usuarios" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuUsers className="sidebar-icon" /><span>Usuarios</span>
              </NavLink>
              <NavLink to="/cvu-info" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuCreditCard className="sidebar-icon" /><span>Info de Cuenta</span>
              </NavLink>
              <NavLink to="/accounts" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuWallet className="sidebar-icon" /><span>Balance</span>
              </NavLink>
              <NavLink to="/movementsx" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuList className="sidebar-icon" /><span>Movimientos</span>
              </NavLink>
              <NavLink to="/transfer" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuArrowLeftRight className="sidebar-icon" /><span>Transferencias</span>
              </NavLink>
              {/* Consolidación deshabilitada temporalmente
              <NavLink to="/consolidacion" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuChartBar className="sidebar-icon" /><span>Consolidación</span>
              </NavLink>
              */}
              <NavLink to="/estado" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuClipboardCheck className="sidebar-icon" /><span>Estado</span>
              </NavLink>
              <NavLink to="/saldo-historico" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuHistory className="sidebar-icon" /><span>Saldo Histórico</span>
              </NavLink>
              <NavLink to="/consulta-coelsa" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuSearch className="sidebar-icon" /><span>Consulta Coelsa</span>
              </NavLink>
              <NavLink to="/auditoria" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuScrollText className="sidebar-icon" /><span>Auditoría</span>
              </NavLink>
              <NavLink to="/clp" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuGlobe className="sidebar-icon" /><span>CLP</span>
              </NavLink>
              <NavLink to="/seguridad" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuLock className="sidebar-icon" /><span>Seguridad</span>
              </NavLink>
            </>
          )}

          {roleReady && userRole === 'BIND' && isPortalUser && (
            <>
              <NavLink to="/mis-cvus" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuCreditCard className="sidebar-icon" /><span>Mis CVUs</span>
              </NavLink>
              <NavLink to="/movements" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuList className="sidebar-icon" /><span>Movimientos</span>
              </NavLink>
              <NavLink to="/transfer" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuArrowLeftRight className="sidebar-icon" /><span>Transferencias</span>
              </NavLink>
            </>
          )}

          {roleReady && userRole === 'BIND' && !isPortalUser && (
            <>
              {isOperator && (
                <NavLink to="/bind-usuarios" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                  <LuUsers className="sidebar-icon" /><span>Usuarios</span>
                </NavLink>
              )}
              <NavLink to="/accounts" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuWallet className="sidebar-icon" /><span>Cuentas</span>
              </NavLink>
              <NavLink to="/movements" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuList className="sidebar-icon" /><span>Movimientos</span>
              </NavLink>
              <NavLink to="/cvu" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuCirclePlus className="sidebar-icon" /><span>Alta CVU</span>
              </NavLink>
              <NavLink to="/baja-cvu" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuTrash2 className="sidebar-icon" /><span>Baja CVU</span>
              </NavLink>
              <NavLink to="/transfer" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`} onClick={closeSidebar}>
                <LuArrowLeftRight className="sidebar-icon" /><span>Transferencias</span>
              </NavLink>
            </>
          )}
        </nav>

        <div className="sidebar-footer">
          {showNotificationButton && (
            <button
              className={`sidebar-notifications ${notificationsEnabled ? 'enabled' : 'disabled'}`}
              onClick={() => setShowNotificationModal(true)}
            >
              {notificationsEnabled ? <LuBell /> : <LuBellOff />}
              <span>{notificationsEnabled ? 'Notificaciones' : 'Silenciado'}</span>
            </button>
          )}
          <button onClick={logout} className="sidebar-logout">
            <LuLogOut />
            <span>Cerrar sesión</span>
          </button>
        </div>
      </aside>

      {showNotificationModal && (
        <div className="notification-modal-overlay" onClick={() => setShowNotificationModal(false)}>
          <div className="notification-modal" onClick={(e) => e.stopPropagation()}>
            <div className="notification-modal-header">
              {notificationsEnabled ? <LuBell className="modal-icon active" /> : <LuBellOff className="modal-icon inactive" />}
              <h3>Notificaciones</h3>
            </div>
            <div className="notification-modal-body">
              {notificationsEnabled ? (
                <>
                  <p>Las notificaciones están <strong>activadas</strong>.</p>
                  <p>¿Deseas desactivarlas?</p>
                </>
              ) : (
                <>
                  <p>Las notificaciones están <strong>desactivadas</strong>.</p>
                  <p>¿Deseas activarlas?</p>
                </>
              )}
            </div>
            <div className="notification-modal-actions">
              <button className="btn-primary" onClick={() => handleToggleNotifications(!notificationsEnabled)}>Sí</button>
              <button className="btn-secondary" onClick={() => setShowNotificationModal(false)}>No</button>
            </div>
          </div>
        </div>
      )}

      <div className="main-wrapper">
        <header className="topbar">
          <button className="topbar-menu" onClick={() => setSidebarOpen(true)}>
            <LuMenu />
          </button>
          <div className="topbar-spacer" />
          <button
            type="button"
            className="topbar-bell"
            aria-label="Notificaciones"
            onClick={() => {
              if (showNotificationButton) setShowNotificationModal(true)
              else setBellNote((open) => !open)
              setProfileOpen(false)
            }}
          >
            <LuBell />
          </button>
          {bellNote && !showNotificationButton && (
            <div className="topbar-pop" role="status">No hay notificaciones.</div>
          )}
          <button
            type="button"
            className="topbar-user-avatar"
            aria-label="Perfil"
            aria-expanded={profileOpen}
            onClick={() => { setProfileOpen((open) => !open); setBellNote(false) }}
          >
            F
          </button>
          {profileOpen && (
            <div className="topbar-pop topbar-profile">
              <p>{username || 'Flash'}</p>
              <button type="button" onClick={logout}>Cerrar sesión</button>
            </div>
          )}
        </header>
        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default Dashboard
